import React from 'react';
import Navbar from '../components/navbar/navbar';
import Contact from '../components/body/contact';
import Footer from '../components/footer/footer';



const Contactpage = () => {
    return (
        <div>
            
            <Contact/>
            
            
            
        </div>
    );
}

export default Contactpage;
